import { render, staticRenderFns } from "./AlbumDetail.vue?vue&type=template&id=793e11d1&scoped=true&"
import script from "./AlbumDetail.vue?vue&type=script&lang=js&"
export * from "./AlbumDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlbumDetail.vue?vue&type=style&index=0&id=793e11d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "793e11d1",
  null
  
)

export default component.exports